import "../CSS/ingresarCodigo.css";

import React, { useRef, useEffect, useState, Fragment } from "react";
import { storage } from "../FirebaseConfig/firebase";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { db } from "../FirebaseConfig/firebase";
import { getDoc, setDoc, doc } from "firebase/firestore";
import { useNavigate, useParams, Link } from "react-router-dom";
import dayjs from "dayjs";
import TextField from "@mui/material/TextField";
import { addDoc, updateDoc } from "firebase/firestore";
import { collection } from "firebase/firestore";
import { QRCodeCanvas } from "qrcode.react";
import { useLocation } from "react-router-dom";
import logo from "../img/logo_cip.png";
import axios from "axios";

const MySwal = withReactContent(Swal);

function EntradaParrilla(props) {
  const navigate = useNavigate();
  const {
    nombre,
    fecha,
    nombreParticipante,
    asientos,
    id,
    idTicket,
    handleConvert,
    fechaReserva,
    numeroParticipantes,
    zona,
    estadoPago,
	categoriasEdad,
	observaciones
  } = props;

  const [datosCargados, setDatosCargados] = useState(true); // MOSTRAR BARRA DE CARGA
  const [shortUrl, setShortUrl] = useState("");
  const opcionesDeFormato = { day: "numeric", month: "long", year: "numeric" };

  const handleShortenUrl = async () => {
    try {
      const response = await axios.get(
        `https://tinyurl.com/api-create.php?url=${encodeURIComponent(
          window.location.href
        )}`
      );
      //console.log("link corto " + response.data.replace("https://", ""));
      setShortUrl(response.data.replace("https://", ""));
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const qrcode = (
    <QRCodeCanvas
      style={{ marginTop: "10px" }}
      id="qrCode"
      value={shortUrl}
      size={150}
      bgColor={"#ffffff"}
      level={"H"}
    />
  );

  useEffect(() => {
    handleShortenUrl();
	console.log("a ver" + observaciones + "a ver")
  }, []);
  useEffect(() => {
    handleConvert();
  }, [shortUrl]);
  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`../img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }
  const backgroundStyle = {
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundColor: "#ecedef ",
    // Otros estilos opcionales
  };
  return (
    <div className="codigo" style={backgroundStyle}>
      <div className="codigo-root" style={{ padding: "0px" }}>
        <div className="codigo-padreIzquierda">
          <div className="codigo-hIzquierda">
            <h1 className="ts-fecha-compra">
              <span>Fecha de emisión</span>

              <br />
              <span>{fechaReserva}</span>
            </h1>
          </div>
        </div>
        <div className="codigo-padreDerecha">
          <div className="codigo-hDerecha">
            <div style={{ display: "flex", justifyContent: "center" }}>
              {qrcode}
            </div>
            <div className="codigo-asientos">
              <h4 style={{marginBottom:"0px",fontWeight:"bold"}}>
                <span> {numeroParticipantes} Invitado(s)</span>
              </h4>
			  <h5 style={{marginTop:"0px",fontWeight:"normal"}}>
                <span> {categoriasEdad}</span>
              </h5>
            </div>

            <form action="/" className="codigo-form">
              <a style={{ fontSize: "18px", margin: "0", paddingTop: "0px" }}>
                {nombreParticipante}
              </a>
              <a style={{ fontSize: "16px", margin: "0", color: "#af9e07" }}>
                Nombre y Apellido
              </a>

              <a style={{ fontSize: "18px", margin: "0", paddingTop: "10px" }}>
                {zona}
              </a>
              <a style={{ fontSize: "16px", margin: "0", color: "#af9e07" }}>
                Zona de parrilla
              </a>
			  
              <a style={{ fontSize: "18px", margin: "0", paddingTop: "10px" }}>
                {new Date(fecha + "T17:00:00Z").toLocaleString(
                  "es-ES",
                  opcionesDeFormato
                )}
              </a>

              <a
                style={{
                  fontSize: "16px",
                  margin: "0",
                  color: "#af9e07",
                }}
              >
                Fecha de reserva
              </a>
			  {observaciones== ""? <a style={{ fontSize: "18px", margin: "0", paddingTop: "10px" }}>
              Ninguna
              </a> :
			  <a style={{ fontSize: "18px", margin: "0", paddingTop: "10px" }}>
                {observaciones}
              </a> }
			  <a style={{ fontSize: "16px", margin: "0", color: "#af9e07" }}>
                Observaciones
              </a>
              <a style={{ fontSize: "18px", margin: "0", paddingTop: "10px" }}>
                {estadoPago}
              </a>
              <a
                style={{
                  fontSize: "16px",
                  margin: "0",
                  color: "#af9e07",
                  paddingBottom: "20px",
                }}
              >
                Estado de pago
              </a>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EntradaParrilla;
